import { color } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import { getColor } from './utils.js';
import { Box } from '../Box/Box.js';
import { Flex } from '../Flex/Flex.js';

const DatepickerStyle = styled(Flex)(({ inContainer, theme: { olist: theme } }) => {
    if (inContainer) {
        return css `
        box-sizing: border-box;
        font-family: inherit;
        max-width: 290px;
      `;
    }
    return css `
      border: 1px solid ${theme.color.neutral.softer};
      border-radius: ${theme.borderRadius.medium};
      box-sizing: border-box;
      box-shadow: ${theme.shadow.low};
      font-family: inherit;
      max-width: 290px;
      padding: ${theme.spacing.stack.medium} ${theme.spacing.inline.small};
    `;
});
const DatepickerInputsContainerStyle = styled(Flex) `
  margin-bottom: 30px;

  > div:first-of-type {
    margin-right: 12px;
  }
`;
const MonthsContainerStyle = styled(Box)(({ theme: { olist: theme } }) => css `
    margin-bottom: ${theme.spacing.stack.small};
  `);
const MonthHeaderStyle = styled(Flex) `
  margin: 0 0 22px;
  text-align: center;
`;
const MonthNavStyle = styled.button `
  background: transparent;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  margin: 0;
  outline: none;
  padding: 0;
`;
const WeekdaysGridStyle = styled.div `
  display: grid;
  grid-template-columns: repeat(7, 38px);
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 12px;
`;
const WeekdayContainerStyle = styled.div(({ theme: { olist: theme } }) => css `
    color: ${theme.color.neutral.base};
    font-size: ${theme.fontSize['3xsmall']};
    text-align: center;
    width: 38px;
  `);
const DaysGridStyle = styled.div(({ theme: { olist: theme } }) => css `
    display: grid;
    grid-template-columns: repeat(7, 38px);
    grid-row-gap: ${theme.spacing.stack['1xsmall']};
    justify-content: center;
    align-items: center;
    text-align: center;
  `);
const DayContainerStyle = styled.div(({ isSelectedStartOrEnd, isSelectedOrHoverRange, disabled, theme: { olist: theme }, }) => css `
    ${color};
    display: flex;
    justify-content: center;

    background-color: ${getColor(isSelectedStartOrEnd, isSelectedOrHoverRange, theme.color.neutral.softest, theme.color.primary.softer, theme.color.neutral.softest)};

    ${disabled &&
    css `
      background: transparent;
    `}
  `);
const DayButtonStyle = styled.button(({ disabled, shouldHaveHover, isSelectedStartOrEnd, isSelectedOrHoverRange, theme: { olist: theme }, }) => css `
    border: 0;
    border-radius: ${theme.borderRadius['1xsmall']};
    ${color};
    cursor: pointer;
    display: block;
    font-family: inherit;
    font-size: ${theme.fontSize['3xsmall']};
    height: 30px;
    outline: none;
    width: 30px;

    background-color: ${getColor(isSelectedStartOrEnd, isSelectedOrHoverRange, theme.color.primary.base, theme.color.primary.softer, theme.color.neutral.softest)};

    color: ${getColor(isSelectedStartOrEnd, isSelectedOrHoverRange, theme.color.neutral.softest, theme.color.primary.base, theme.color.neutral.stronger)};

    &:focus {
      outline: none;
    }

    ${shouldHaveHover &&
    css `
      &:hover {
        border: 1px solid ${theme.color.primary.base};
        color: ${theme.color.primary.base};
      }
    `}

    ${disabled &&
    css `
      &,
      &:hover {
        background: transparent;
        border: none;
        color: ${theme.color.neutral.soft};
        cursor: default;
      }
    `}
  `);

export { DatepickerInputsContainerStyle, DatepickerStyle, DayButtonStyle, DayContainerStyle, DaysGridStyle, MonthHeaderStyle, MonthNavStyle, MonthsContainerStyle, WeekdayContainerStyle, WeekdaysGridStyle };
